import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header bg-accent text-white border-0" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-12 px-2" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = {
  key: 1,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.modalSizeClass),
            role: "document"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onHide && _ctx.onHide(...args))),
                  type: "button",
                  class: "close text-white",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                }, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "body", {}, () => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.bodyText), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "footer", {}, () => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHide && _ctx.onHide(...args)))
                  }, "Tidak"),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-accent",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)), ["prevent"]))
                  }, "Ya")
                ])
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}